<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <FinancialContractForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import FinancialContractForm from '@/components/settings/financial/contract/FinancialContractForm'

export default {
  name: 'FinancialContractAddView',
  components: {
    PageTitle,
    PageRowWrapper,
    FinancialContractForm
  }
}
</script>
